module.exports = __webpack_public_path__ + "img/20190720121753QQ截图20190720091402.9fad52ba.png";